


































































import Vue from "vue";
import { mapActions } from "vuex";
import {
  APP_ASSESSMENT_ANSWERS,
  APP_ASSESSMENT_QUESTIONNAIRES
} from "@/store/modules/candidates/constants";
import { ScreeningQuestionsResponse } from "@/store/modules/recruiter/interfaces";
import { required_rules } from "@/utils/global";
import {
  FetchAssessmentAnswersApiPayload,
  QuestionnairePayload
} from "@/store/modules/candidates/interfaces";
import DataNotFound from "@/components/shared/DataNotFound.vue";
import { AssessmentQuestionnairesWithAns } from "@/store/modules/my_next_move/interfaces";

export default Vue.extend({
  name: "ViewCandidateScreeningQuestions",
  components: {
    DataNotFound
  },
  data() {
    return {
      dialog: true,
      screened_questions: [] as ScreeningQuestionsResponse[],
      data_message: "No Questions Found",
      answer_options: [] as AssessmentQuestionnairesWithAns[],
      loading: false
    };
  },
  props: {
    candidate_id: {
      type: Number
    },
    job_id: {
      type: Number
    },
    created_by: {
      type: Number
    },
    screened_assessment_id: {
      type: Number
    }
  },
  mounted() {
    this.fetch_assessment_questions();
  },
  methods: {
    required_rules,
    ...mapActions("candidate", {
      get_assessment_question: APP_ASSESSMENT_QUESTIONNAIRES,
      get_assessment_answer: APP_ASSESSMENT_ANSWERS
    }),
    async fetch_assessment_questions() {
      this.loading = true;

      if (!this.screened_assessment_id || !this.job_id || !this.candidate_id)
        return;

      const assessment_questions = await this.get_assessment_question({
        assessment_id: this.screened_assessment_id,
        job_id: this.job_id,
        created_by: this.created_by
      });
      // const _screened_questions  = [] as ScreeningQuestionsResponse[];
      if (assessment_questions) {
        const question_ids = assessment_questions.map(
          (question: QuestionnairePayload) => question.id
        );
        if (question_ids) {
          // Fetch assessment answer
          const answer: FetchAssessmentAnswersApiPayload = {
            assessment_id: this.screened_assessment_id,
            page: 0,
            limit: 10,
            user_id: this.candidate_id,
            question_ids: question_ids
          };
          const answers = await this.get_assessment_answer(answer);
          if (answers && answers.results && answers.results.length) {
            this.screened_questions =
              assessment_questions as ScreeningQuestionsResponse[];
            this.answer_options = answers.results;
          } else {
            this.answer_options = [];
            this.screened_questions = [];
            this.data_message = "Questions not answered yet";
          }
        }
      }
      this.loading = false;
    },
    get_options(index: number) {
      return this.screened_questions[index]?.question_options?.options;
    },
    get_answers_of_desired_question(question_id: number) {
      const answer = this.answer_options.find(
        (item) => item.question_id === question_id
      );

      return answer ? answer.answer : "Not Answered";
    },
    on_close() {
      this.screened_questions = [];
      this.answer_options = [];
      this.data_message = "No Questions Found";
      this.$emit("close");
    }
  }
});
